import React, { useState } from 'react'; // Added useState
// import Logo from '../assets/logo-sylents-white.svg'; // REMOVED Incorrect import
import { ArrowRight } from 'lucide-react'; // Import icon for button
import { useTranslation, Trans } from 'react-i18next'; // Added Trans
import { motion } from 'framer-motion';
import ScrollIndicator from './ScrollIndicator'; // Import ScrollIndicator
import FAQModal from './FAQModal'; // Import FAQModal
// import client from '../lib/sanityClient'; // REMOVED Sanity client import

function HeroSection() {
  const { t } = useTranslation(); // Initialize the hook, no need for i18n instance here
  const [isFAQModalOpen, setIsFAQModalOpen] = useState(false); // Add state for FAQ modal

  // Function to handle scroll, simple JS for now
  const scrollToContact = () => {
    document.getElementById('kontakt')?.scrollIntoView({ behavior: 'smooth' });
  };

  // Function to handle opening FAQ modal
  const openFAQModal = () => {
    setIsFAQModalOpen(true);
  };

  return (
    // Using section tag and class names from global styles
    <section 
      className="hero" 
      id="hero" 
      style={{ 
        // minHeight: '100vh', // Removed to allow CSS file to control height
        textAlign: 'center', 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        padding: '2rem' 
      }}
    > 
      {/* Added logo back */}
      <motion.img 
        src="/images/logo.svg" // CORRECTED path to public asset
        alt="Sylents Logo" 
        className="hero-logo" 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      />
      
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        {/* Use i18next t() function */}
        {t('heroTitle')}
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.6 }}
        style={{ color: 'black' }}
      >
        <Trans i18nKey="heroSubtitle">
          Become part of our worldwide expansion by investing in <a href="#" onClick={(e) => { e.preventDefault(); openFAQModal(); }} style={{ color: '#17a4b0', textDecoration: 'none', cursor: 'pointer' }}>tokenized bonds</a>.
        </Trans>
      </motion.p>
      <motion.div
        className="cta-buttons"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.8 }}
      >
        <a 
          href="#contact" 
          className="cta-button" 
        >
          {t('requestInviteButton')}
        </a>
      </motion.div>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 1.0 }}
      >
        <ScrollIndicator />
      </motion.div>

      {/* Add FAQ Modal */}
      {isFAQModalOpen && (
        <FAQModal onClose={() => setIsFAQModalOpen(false)} />
      )}
    </section>
  );
}

export default HeroSection; 